import { useEffect, useState } from 'react'
import Select from 'react-select'
import { AiOutlineFilter } from 'react-icons/ai'
import { Get_SubjectCategory_ID_Children } from '../../api/api'
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';


export default function Multiselect({ clear }) {

  const [selectedOption, setSelectedOption] = useState(null)
  const [options, setOptions] = useState([]);

  const [isChange, setIsChange] = useState('');

  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const params = useParams()
  const children = Get_SubjectCategory_ID_Children(params.typeId)

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption)
    const catIDs = [];
    for (let i = 0; i < selectedOption.length; i++) {
      catIDs.push(selectedOption[i].value)
    }
    setSearchParams({ SubjectCategoryList: catIDs });
  }

  useEffect(() => {
    setSelectedOption('')
  }, [isChange, clear]);

  useEffect(() => {
    setLoading(true)
    setOptions([])
    const getChild = async () => {
      try {
        const res = await axios.get(children)
        for (let i = 0; i < res.data.length; i++) {
          setOptions(prev => [{
            value: res.data[i].id, label: res.data[i].title
          }, ...prev])
        }
      } finally {
        setLoading(false)
      }
    }

    getChild()

    if (JSON.stringify(params) !== JSON.stringify(isChange)) {
      setIsChange(params)
    }
  }, [params]);

  return (
    <>
      <div className='multiS flex'>
        <span className='filterHolder'>
          <AiOutlineFilter /> <span className='filter'>فیلتر :</span>
        </span>
        <Select
          placeholder='دسته بندی'
          value={selectedOption}
          onChange={handleChange}
          options={options}
          isLoading={loading}
          isMulti
          isRtl
        />

      </div>
    </>
  )
}
